@use "src/sedestral/sass/mixins/texts";
@use "src/sedestral/sass/icons/icons";

.componentWebsiteBlackText {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  @include texts.font("semi-bold");

  &.sizeNormal {
    .content {
      max-width: 840px;
      font-size: 28px;
    }
  }

  &.sizeMid {
    .content {
      max-width: 1000px;
      font-size: 32px;
    }
  }

  &.sizeBig {
    .content {
      max-width: 100%;
      font-size: 36px;

      @include texts.font("bold");
    }
  }

  &.colorBlue {
    .shadow {
      background: var(--web-blue);
    }
  }

  &.colorGreen {
    .shadow {
      background: var(--web-green);
    }

    span {
      color: var(--web-green);
    }
  }

  &.colorPurple {
    .shadow {
      background: var(--web-purple);
    }
  }

  .shadow {
    width: 409px;
    height: 126px;
    filter: blur(100px);
    position: absolute;
    will-change: filter, transform;
  }

  .content {
    position: relative;
    padding: 15px 0;
    font-size: 32px;
    z-index: 1;

    .google {
      width: 131px;
      height: 43px;
      top: 11px;
      margin-top: -10px;
      display: inline-flex;
      position: relative;

      @include icons.ico("colored-google-text");
    }
  }

  @media screen and (max-width: 930px) {
    .content {
      font-size: 28px !important;

      .google {
        width: 118px !important;
        height: 39px !important;
        margin-top: -14px !important;
      }
    }
  }
}